import React, { useState } from "react";
import { TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons";
import { apiWithInterceptor } from "../../../../api";
const SearchBox = ({
  setVisible,
  state,
  setElements,
  ItemPerPage,
  offset,
  setData,
}) => {
  const [searchFor, setSearchFor] = useState("");
  return (
    <TextInput
      style={{ width: "980px" }}
      placeholder="Search for any keyword and press enter"
      mb="md"
      icon={<IconSearch size={14} stroke={1.5} />}
      onChange={(e) => {
        setSearchFor(e.target.value);
      }}
      onKeyPress={(e) => {
        if (e.charCode === 13) {
          if (searchFor !== "") {
            setVisible(true);
            apiWithInterceptor
              .post(
                `/session/search/${state.sessionID}`,

                {
                  field_value: searchFor,
                }
              )
              .then((res) => {
                setElements(res.data);
                setVisible(false);
              })
              .catch(() => {
                setVisible(false);
              });
          } else {
            setVisible(true);
            apiWithInterceptor
              .get(
                `/ticket?session_id=${state.sessionID}&limit=${ItemPerPage}&offset=${offset}`
              )
              .then((res) => {
                setElements(res.data.array);
                setData(res.data);
                setVisible(false);
              })
              .catch(() => {
                setVisible(false);
              });
          }
        }
      }}
    />
  );
};

export default SearchBox;
